const googleTranslate = () => {
    const loadGoogleTranslateScript = () => {
      const existingScript = document.getElementById('google-translate-script')
      if (existingScript) {
        document.body.removeChild(existingScript)
      } else {
        const script = document.createElement('script')
        script.id = 'google-translate-script'
        script.src =
          '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&hl=en'
        script.async = true
        script.defer = true

        document.body.appendChild(script)
      }
    }

    window['googleTranslateElementInit'] = () => {
        try {
            const TranslateElement = window['google']?.translate.TranslateElement
            if (!TranslateElement) return
            new TranslateElement(
            {
                pageLanguage: 'en',
                includedLanguages: 'en,es,fr,de,it,ru,ar,pt,zh-CN,tr',
                autoDisplay: false
            },
            'google_translate_element'
            )
            const element = document.querySelector('.skiptranslate')
            if (element)
            element.childNodes.forEach((item) => {
                item.data = ''
            })
        } catch (err) {
            console.warn(err)
        }
    }

    loadGoogleTranslateScript()
}

export default googleTranslate
